import React, { useEffect, useState } from "react"
import { useIdleTimer } from "react-idle-timer"

export default function useIdle({
  onIdle,
  onPromptIdle,
  idleTime = 300000,
  promptTime = 60000,
}) {
  const onAction = (event: Event, idleTimer: IIdleTimer) => {
    //if (idleTimer.isPrompted())
  }

  const onActive = (event: Event, idleTimer: IIdleTimer) => {
    //if (idleTimer.isPrompted())
  }

  const handleOnPromptIdle = () => {
    onPromptIdle()
  }

  const handleOnIdle = () => {
    onIdle()
  }

  const { getRemainingTime, getLastActiveTime, isIdle, activate } =
    useIdleTimer({
      timeout: idleTime,
      promptBeforeIdle: promptTime,
      onAction,
      onActive,
      onPrompt: handleOnPromptIdle,
      onIdle: handleOnIdle,
    })

  return {
    getRemainingTime,
    getLastActiveTime,
    isIdle,
    activate,
  }
}
